@for (load of indicatorLoads(); track load) {
  @if (failedLoad() !== load) {
    @switch (load.type) {
      @case ('default') {
        <ng-lottie
          aria-hidden="true"
          [options]="load.options"
          (animationCreated)="onAnimationCreated($event, load)"
        />
      }
      @case ('gif') {
        <img
          class="gif-animation"
          [class.pending]="loadedGif() !== load"
          [src]="load.url"
          alt=""
          width="160"
          height="160"
          aria-hidden="true"
          (load)="onGifLoaded(load)"
          (error)="onGifError(load)"
        />
      }
    }
  }
}

@if (text(); as caption) {
  <div class="bar">
    <div class="text" dir="auto">{{ caption }}</div>
    <div class="line" aria-hidden="true"></div>
  </div>
}
